export default function ArrowFull() {
    return (
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_599_1600)">
                <path d="M11.3138 6.59968V16.0278M11.3138 16.0278L16.0278 11.3137M11.3138 16.0278L6.59974 11.3137" stroke="#172555" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_599_1600">
                    <rect width="16" height="16" fill="white" transform="translate(22.6274 11.3137) rotate(135)" />
                </clipPath>
            </defs>
        </svg>

    )
}